import React, { useState, useEffect, useMemo } from "react";
import { Avatar_02 } from "../../Routes/ImagePath";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import EssFullWidthModal from "components/modelpopup/baseModal"
import { Button } from "components/Button";
import { Controller } from "react-hook-form";
import {  useSelector } from 'react-redux';
import FilterSelect from "components/Form/filterSelect";
import { updateUniformsAllocationApi} from "api/services/uniforms";
import {  toast, Bounce } from 'react-toastify';

const UniformAllocationStatusModal = ({
    allocationModal,
    setAllocationModal,
    selectedAllocation,
    userData,
    fetchAllocation,
    setSelectedAllocation

}) => {
      
  const {  
    uniformSizes, uniformSizesLoading,
   
} = useSelector((state) => state.common);
const [uniformSizeOption, setUniformSizeOption] = useState([]);

 
  const [loading, setLoading]=  useState(false);

  useEffect(()=>{   
    const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
    
  
    if(uniformSizes){
      let _sizes = [...uniformSizes];
  
      _sizes.sort((a, b) => sizeOrder.indexOf(a.code) - sizeOrder.indexOf(b.code));
      let sizes = _sizes.map(item=> {
        return{
            label: item.code,
            value: item.id
        }
    })
    setUniformSizeOption(sizes)
  

    }
  },[uniformSizes])
  

  const statusOptions = {
    initiated: [{ value: "acknowledged", label: "Acknowledged" }],
    acknowledged: [{ value: "approved", label: "Approved" }],
    returned: [{ value: "approved", label: "Approved" }],
    approved: [
      { value: "received", label: "Received" },
      { value: "returned", label: "Returned" },
    ],
  };


//   const schema = yup.object().shape({
//     status: yup.object().shape({
//       value: yup.string().required("Status is required"),
//     }),
//     size: yup
//       .object()
//       .nullable()
//       .when("selectedAllocation?.status", {
//         is: "initiated",
//         then: yup.object().shape({ value: yup.string().required("Size is required") }),
//       }),
//   });

    // Memoized validation schema
    const schema = yup.object().shape({
          status: yup.object().required("Status is required"),
          size: yup
            .mixed()
            .when([], {
              is: () => selectedAllocation.status === "initiated" && uniformSizeOption.length > 0,
              then: (schema) => schema.required("Leave address is required"),
              otherwise: (schema) => schema,
            }),
        });

        

const {
  register,
  handleSubmit,
  formState: { errors },
  reset,
  control,
  setError,
  setValue,
  watch
} = useForm({
  resolver: yupResolver(schema), // ✅ Apply Yup validation
  defaultValues:{

  }
});


useEffect(()=>{
  if(allocationModal && selectedAllocation?.id){
    

  }
  

}, [allocationModal, selectedAllocation, ])


const handleReset = () => {
  // reset({
  //   name: "",
  //   address_1: "",
  //   address_2: "",
  //   city: "",
  //   country: "",
  //   emergency_contact_name: "",
  //   emergency_contact_number: "",
  // });
  reset();
  setSelectedAllocation("")
};

  const onSubmit = async (data) => {
    console.log(data)
    let payload = {
      ...data,
     
    }
    payload.size = payload?.size?.value
    payload.status = payload?.status?.value

    

    if(selectedAllocation?.id){
      updateAllocationData(payload)
    }else{
    //   createAddressData(payload)
    }
 

  };
  const updateAllocationData = (payload) => {
    setLoading(true)
    updateUniformsAllocationApi(selectedAllocation?.id,payload).then(response=>{

      setAllocationModal(false)
      setLoading(false)
      handleReset()
      toast.success('Allocation status updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        fetchAllocation()
    }).catch(e=>{
      try{
        console.log(e.response.data, "EEEEE")
        // let response = e.response?.data?.error || "Error updating leave status!"
        setLoading(false)
    

      if(e.response.data){
        Object.entries(e.response.data).forEach(([k, v]) => {
          console.log(typeof v,k, "EEEEE")
          setError(k,
            {
              type: 'manual',
              message: v.join(", ")
            }
             )
        })
      }
      }catch(err){
        console.log(err, "LLLLLLL")
        let response = e.response?.data?.error || "Error updating status!"
        setLoading(false)
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        
      }

    })
  }
 
//   const createAddressData = (payload) => {
//     setLoading(true)
//     createAddressApi(payload).then(response=>{

//       setAllocationModal(false)
//       setLoading(false)
//       handleReset()
//       toast.success('Emergency contact created!', {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: false,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "light",
//         transition: Bounce,
//         });
//         fetchAllocation()
//     }).catch(e=>{
//       try{
//         console.log(e.response.data, "EEEEE")
//         // let response = e.response?.data?.error || "Error updating leave status!"
//         setLoading(false)
    

//       if(e.response.data){
//         Object.entries(e.response.data).forEach(([k, v]) => {
//           console.log(typeof v,k, "EEEEE")
//           setError(k,
//             {
//               type: 'manual',
//               message: v.join(", ")
//             }
//              )
//         })
//       }
//       }catch(err){
//         console.log(err, "LLLLLLL")
//         let response = e.response?.data?.error || "Error creating address!"
//         setLoading(false)
//           toast.error(response, {
//             position: "top-right",
//             autoClose: 5000,
//             hideProgressBar: false,
//             closeOnClick: false,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//             theme: "light",
//             transition: Bounce,
//             });
        
//       }

//     })
//   }
 


  const status = watch("status");

  useEffect(() => {
    if (selectedAllocation?.status && !statusOptions[selectedAllocation?.status]?.some((opt) => opt.value === status?.value)) {
      setValue("status", null);
    }
  }, [selectedAllocation?.status, status, setValue]);
  return (
    <>
      <EssFullWidthModal
        mask={false}
        title={selectedAllocation ? "Allocation Status" : ""}
        // style={{ top: 100 }}
        open={allocationModal}
        width={"40%"}
        footer={[]}
        onCancel={() => {
            setAllocationModal(false)
            handleReset()
        
        }}
        className="full-width-modal"
     >
        <div className="modal-content">
            
            <div className="modal-body">

            <form onSubmit={handleSubmit(onSubmit)} className=" p-4 ">
        {/* Status Field */}
        <div className="mb-3 col-md-6 col-sm-12">
          <label className="form-label">Status</label>
          <Controller
            name="status"
            control={control}
            render={({ field: { value, onChange } }) => (
                <FilterSelect
                        {...register("status")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={statusOptions[selectedAllocation?.status] || []}
                        isLoading={false}
                        value={value}
                        placeholder={"Select Status"}
                      />   
            //   <Select
            //     {...field}
            //     options={statusOptions[selectedAllocation?.status] || []}
            //     isClearable
            //     placeholder="Select Status"
            //   />
            )}
          />
          {errors.status && <p className="text-danger">{errors?.status?.message}</p>}
        </div>

        {/* Size Field (Visible only if status is 'initiated') */}
        {selectedAllocation?.status === "initiated" && (
          <div className="mb-3 col-md-6 col-sm-12">
            <label className="form-label">Size</label>
            <Controller
              name="size"
              control={control}
              render={({ field: { value, onChange } }) => (
                <FilterSelect
                        {...register("size")}
                        isClearable={true}
                        onChange={onChange}
                        optionLabel={"label"}
                        optionValue={"value"}
                        options={uniformSizeOption}
                        isLoading={false}
                        value={value}
                        placeholder={"Select Size"}
                      />   
              )}
            />
            {errors.size && <p className="text-danger">{errors?.size?.message}</p>}
          </div>
        )}

          {/* 🔹 Submit Button */}
          <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading}
                    className="btn btn-primary submit-btn"
                    type="submit"
                    label="Submit"
                  />
                </div>
      </form>
            </div>
          </div>


     </EssFullWidthModal>

    

    </>
  );
};

export default UniformAllocationStatusModal;
